import { render } from "./stage7.vue?vue&type=template&id=8ad5efcc&scoped=true"
import script from "./stage7.vue?vue&type=script&lang=js"
export * from "./stage7.vue?vue&type=script&lang=js"

import "./stage7.vue?vue&type=style&index=0&id=8ad5efcc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad5efcc"]])

export default __exports__